module.exports = __webpack_public_path__ + "img/get-inspired.ed243bce.svg";